import { render, staticRenderFns } from "./BroadClient.vue?vue&type=template&id=0f011074"
import script from "./BroadClient.vue?vue&type=script&lang=js"
export * from "./BroadClient.vue?vue&type=script&lang=js"
import style0 from "./BroadClient.vue?vue&type=style&index=0&id=0f011074&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports